import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TriangleLeftIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='triangle-left'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M7.5 10L12.5 5V15L7.5 10Z'
				fill={props?.color || '#2E2E6B'}
			/>
		</svg>
	);
};

export default TriangleLeftIcon;
